import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Guard modules (Lot 1).
 * Usage route: `data: { modules: ['menus'] }` — au moins un module requis.
 * Optionnel: `data: { requireAllModules: true }`
 */
@Injectable({ providedIn: 'root' })
export class ModuleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isLoggedIn()) {
      return this.router.createUrlTree(['/auth/login']);
    }

    const requiredModules = (route.data['modules'] as string[]) || [];
    if (!requiredModules.length) {
      return true;
    }

    const requireAll = !!route.data['requireAllModules'];
    const ok = requireAll
      ? this.authService.hasAllModules(requiredModules)
      : this.authService.hasAnyModule(requiredModules);

    if (!ok) {
      return this.router.createUrlTree(['/access-denied']);
    }
    return true;
  }
}
